(function () {
  function selectSwatch(card, swatch) {
    if (!card || !swatch) return;

    var imageSrc = swatch.getAttribute("data-image");
    var hoverSrc = swatch.getAttribute("data-hover");
    var price = swatch.getAttribute("data-price");
    var href = swatch.getAttribute("href");
    var label = swatch.getAttribute("data-label");

    function resolveImage(node) {
      if (!node) return null;
      if (node.tagName === "IMG") return node;
      return node.querySelector("img");
    }

    var image = resolveImage(card.querySelector(".ubf-design-card__image:not(.ubf-design-card__image--hover)")) || resolveImage(card.querySelector("[data-ubf-card-image]"));
    if (image && imageSrc) {
      image.setAttribute("src", imageSrc);
      if (image.hasAttribute("srcset")) image.removeAttribute("srcset");
    }

    var hover = resolveImage(card.querySelector(".ubf-design-card__image--hover")) || resolveImage(card.querySelector("[data-ubf-card-hover]"));
    if (hover) {
      var nextHover = hoverSrc || imageSrc;
      if (nextHover) {
        hover.setAttribute("src", nextHover);
        if (hover.hasAttribute("srcset")) hover.removeAttribute("srcset");
      }
    }

    card.querySelectorAll("[data-ubf-card-link]").forEach(function (link) {
      if (href) link.setAttribute("href", href);
    });

    var priceNode = card.querySelector("[data-ubf-card-price]");
    if (priceNode && price) priceNode.textContent = price;

    card.querySelectorAll("[data-ubf-swatch]").forEach(function (item) {
      var active = item === swatch;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-current", active ? "true" : "false");
    });

    if (label) card.setAttribute("data-active-colour", label);
  }

  document.addEventListener("click", function (event) {
    var swatch = event.target.closest("[data-ubf-swatch]");
    if (!swatch) return;
    var card = swatch.closest("[data-ubf-design-card]");
    if (!card) return;
    event.preventDefault();
    selectSwatch(card, swatch);
  });
})();
